// Code review - In Progress
// Documentation - In Progress

import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";

const RoomMasterPopup = ({ data,data1 }) => {
  return (
    <div class="w-full ">
      <div class=" border-black  "></div>
      <div class="mx-auto flex justify-center lg:w-2/5 md:w-full w-full border-black">
        <div class="relative w-full h-full max-w-xl md:h-auto">
          <div class="relative bg-white rounded-lg shadow ">
            <div class="px-6 py-6 lg:px-8">
              <form class="space-y-6" action="#">

                <AutoDropDown
                  selectedOption={{ value: data.RoomType, label: data.RoomTypeName }}
                  title="Room Type"
                  classStar={"text-red-500"}
                  inputType="dropdown"
                  options={data1}
                  name="roomType"
                  disabled={true}
                  placeholder="Room Type"
                  Class="custom-class"
                  // tabIndex="1"
                  maxLength={50}
                />
                <InputText
                  inputType={"text"}
                  classStar="text-red-500"
                  title={"Room"}
                  name={"room Name"}
                  content={data?.RoomName || ""}
                  disabled="disabled"
                />
                
                <TextArea
                  inputType="text"
                  title="Description"
                  name="description"
                  maxLength={200}

                  disabled={true}
                  content={data.Description}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomMasterPopup;
